<template>
  <v-card :loading="loading">
    <v-card-title>
      SIM Status

      <div class="flex-grow-1"></div>

      <v-btn icon @click="editable = !editable">
        <v-icon v-if="!editable">mdi-pencil</v-icon>
        <v-icon v-else>mdi-close</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text v-if="simStatus">
      <!-- <v-row v-for="(item, index) in headers" :key="index"> -->
      <!--   <v-col class="text-right">{{ item.text }}</v-col> -->
      <!--   <v-col class="text-left" v-if="editable && item.text === 'Status'"> -->
      <!--     <v-select :items="availableSIMStatuses" v-model="selectedSIMStatus" @change="setSIMStatus"></v-select> -->
      <!--   </v-col> -->
      <!--   <v-col class="text-left" v-else>{{ simStatus[item.value] }}</v-col> -->
      <!-- </v-row> -->

      <v-row>
        <v-col class="text-right">ICCID</v-col>
        <v-col class="text-left">{{ simStatus.iccid }}</v-col>
      </v-row>
      <v-row>
        <v-col class="text-right">MSISDN</v-col>
        <v-col class="text-left">{{ simStatus.msisdn }}</v-col>
      </v-row>
      <v-row>
        <v-col class="text-right">IMSI</v-col>
        <v-col class="text-left">{{ simStatus.imsi }}</v-col>
      </v-row>
      <v-row>
        <v-col class="text-right">Status</v-col>
        <v-col class="text-left" v-if="editable">
          <v-select :items="availableSIMStatuses" v-model="selectedSIMStatus" dense @change="setSIMStatus"></v-select>
        </v-col>
        <!-- <v-col class="text-left font-weight-bold" :class="simStatusColor" v-else>{{ availableSIMStatuses.find(status => status.value === simStatus.status).text }}</v-col> -->
        <v-col class="text-left font-weight-bold" :class="simStatusColor" v-else>{{ simStatus.status }}</v-col>
      </v-row>

    </v-card-text>
  </v-card>
</template>

<script>
import axios from 'axios'

export default {
  name: 'itemSIMStatus',

  props: ['propItem'],

  data: () => ({
    showCard: false,
    loading: false,
    simStatus: null,
    // cardStatus: 1,
    editable: false,
    availableSIMStatuses: [
      { text: 'ACTIVATED', value: 'ACTIVATED' },
      { text: 'DEACTIVATED', value: 'DEACTIVATED' }
    ],
    selectedSIMStatus: null
  }),

  mounted () {
    console.log('ItemSIMStatus.vue - mounted() triggered')
    this.getItemSIMStatus(this.propItem.iccid)
  },

  computed: {
    simStatusColor () {
      const locationIsCustomer = this.propItem.Location.name === 'Customer'
      const haveCustomer = !!this.propItem.CustomerId
      const simStatus = this.simStatus.status

      if (locationIsCustomer && haveCustomer) {
        if (simStatus === 'ACTIVATED') return 'success--text'
        if (simStatus === 'DEACTIVATED') return 'blue--text'
      } else {
        if (simStatus === 'ACTIVATED') return 'warning--text'
        if (simStatus === 'DEACTIVATED') return 'success--text'
      }

      return null
    }
  },

  methods: {
    getItemSIMStatus (iccid) {
      this.loading = true
      axios.get(process.env.VUE_APP_API_URL + '/item/' + iccid + '/simStatus')
        .then(result => {
          this.simStatus = result.data
          this.selectedSIMStatus = result.data.status
          this.loading = false

          this.setCardStatus()
        })
        .catch(err => {
          console.error('Error trying to get item SIM Status:' + err)
          this.loading = false
        })
    },

    setSIMStatus () {
      this.loading = true
      axios.put(process.env.VUE_APP_API_URL + '/item/' + this.propItem.iccid + '/simStatus', { status: this.selectedSIMStatus })
        .then(result => {
          console.log('result', result)
          this.$store.commit('setSnackbarText', 'Successfully changed SIM Status to ' + this.selectedSIMStatus)
          this.$store.commit('setSnackbarColor', 'success')
          this.$store.commit('setSnackbar', true)
          this.simStatus.status = this.selectedSIMStatus
          this.editable = false
          this.loading = false
          this.setCardStatus()
        })
        .catch(err => {
          console.error('Error trying to set item SIM status:' + err)
          this.loading = false
        })
    }

    // setCardStatus () {
    //   if (this.selectedSIMStatus === 'DEACTIVATED') {
    //     this.cardStatus = 2
    //   }
    // }
  }
}
</script>

<style>

</style>
